import {
  CHANNEL_NAME_PARAM,
  PurchaseChannel,
} from "@redotech/redo-model/warranties";
import { memo } from "react";
import { EmailLink } from "./email-link";
const purchaseChannelToTitle: Record<PurchaseChannel, string> = {
  [PurchaseChannel.ONLINE]: "Let's find your order",
  [PurchaseChannel.RETAIL]: "Let's verify your email",
};

const purchaseChannelToNextUrl: Record<PurchaseChannel, string> = {
  [PurchaseChannel.ONLINE]: "/returns-portal/orders/register",
  [PurchaseChannel.RETAIL]: "/returns-portal/retail/register",
};

function constructNextUrl(
  purchaseChannel: PurchaseChannel,
  channelName: string,
) {
  const urlParams = new URLSearchParams();
  urlParams.set(CHANNEL_NAME_PARAM, channelName);
  return `${purchaseChannelToNextUrl[purchaseChannel]}?${urlParams.toString()}`;
}

export const RegisterOtp = memo(function RegisterOtp({
  onBack,
  purchaseChannel,
  channelName,
}: {
  onBack: () => void;
  purchaseChannel: PurchaseChannel | undefined;
  channelName: string;
}) {
  if (!purchaseChannel) {
    return null;
  }
  return (
    <EmailLink
      nextUrl={constructNextUrl(purchaseChannel, channelName)}
      onBack={onBack}
      showFooter={false}
      title={purchaseChannelToTitle[purchaseChannel]}
    />
  );
});
